import React from "react";
import { FormattedMessage } from "react-intl";
import { useTheme } from "styled-components";
import { DeviceType } from "../../domain/orchestrationCriteria.entity";
import {
  criteriaModalMessages as messages,
  useDeviceTypeLabels,
} from "../../../orchestrator.messages";

interface DeviceInputProps {
  deviceTypes: DeviceType[];
  onToggle: (device: DeviceType) => void;
}

export function DeviceInput({ deviceTypes, onToggle }: DeviceInputProps) {
  const theme = useTheme();
  const deviceTypeLabels = useDeviceTypeLabels();

  return (
    <div>
      <label className="block font-medium text-gray-700 mb-2">
        <FormattedMessage {...messages.deviceTypes} />
      </label>
      <div className="flex flex-wrap gap-2">
        {Object.values(DeviceType)
          .filter(d => d !== DeviceType.DEVICE_TYPE_UNSPECIFIED)
          .map(device => (
            <label
              key={device}
              className={`px-3 py-1 rounded border cursor-pointer text-sm ${
                deviceTypes.includes(device)
                  ? `bg-[${theme.textColor}] text-white border-[${theme.textColor}]`
                  : "bg-white text-gray-700 border-gray-300 hover:bg-gray-50"
              }`}>
              <input
                type="checkbox"
                checked={deviceTypes.includes(device)}
                onChange={() => onToggle(device)}
                className="sr-only"
              />
              {deviceTypeLabels[device]}
            </label>
          ))}
      </div>
    </div>
  );
}
